<template>
    <v-card class="pa-4 bordered teacher-card">
        <div class="d-flex flex-column align-center">
            <v-avatar :size="72" class="bordered mb-2">
                <v-img :src="teacher.avatar"></v-img>
            </v-avatar>
            <div class="mb-3 text-center">
                <div class="medium-text strong-text--text">{{ teacher.name }}</div>
                <div v-if="teacher.subjects && teacher.subjects.length" class="muted--text details-text">
                    {{ teacher.subjects.map(subject => subject.name).join(', ') }}
                </div>
            </div>
            <div class="w-100">
                <v-btn block depressed color="primary" :to="{ name: 'teacher', params: { id: teacher.id } }">
                    دورات المعلم
                </v-btn>
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    props: {
        teacher: {
            type: Object,
            required: true,
        },
    },
};
</script>
